<div>
  <mat-label>{{ title }}</mat-label>
</div><br>
<div>
  <span style="margin-right: 20px">【　{{ meisai.item }}</span>
  <span>{{ meisai.subItem }}　】</span>
</div><br>
<form #form="ngForm">
  <mat-form-field class="input-margin">
    <mat-label>
      閾値
    </mat-label>
    <input matInput required placeholder="閾値" type="number"
           name="shikiiChi" [(ngModel)]="meisai.shikiiChi">
  </mat-form-field>
  <span>{{ meisai.bikou }}</span>
</form>
<div mat-dialog-actions align="end">
  <button mat-button mat-flat-button color="primary" (click)="commonService.onClick(this.matDialogRef, meisai)" [disabled]="form.invalid || !form.dirty">
    <span>Enter</span>
  </button>
</div>

